import React, { useEffect, useState } from 'react';
import api from '../service/Api';
import { Paper, Grid, Typography, TextField, Button, Box, CircularProgress } from '@mui/material';
import { useSnackbar } from 'notistack';

function Perfil() {
    const [user, setUser] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: ''
    });

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('No token found');
                }

                const response = await api.get('/api/perfil', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.status !== 200) {
                    throw new Error('Failed to fetch user data');
                }

                setUser(response.data.user);
                setFormData({
                    name: response.data.user.name,
                    email: response.data.user.email,
                    password: ''
                });
            } catch (error) {
                setError(error.message);
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
    };

    const handleEditToggle = () => {
        setIsEditing(!isEditing);
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('No token found');
            }

            const response = await api.put(`/api/user/${user.id}`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status !== 200) {
                throw new Error('Failed to update user data');
            }

            setUser(response.data.user);
            setIsEditing(false);
            enqueueSnackbar('Usuário editado com sucesso!', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            setError(error.message);
            console.error(error);
        }
    };

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <CircularProgress />
            </Grid>
        );
    }

    if (error) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
                <Typography color="error">Error: {error}</Typography>
            </Grid>
        );
    }

    return (
        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '75vh' }}>
            <Grid item xs={10} sm={8} md={6}>
                <Paper elevation={3} style={{ padding: 20, borderRadius: 15 }}>
                    {user ? (
                        <Box>
                            <Typography variant="h4" gutterBottom>Perfil do Usuário</Typography>
                            <TextField
                                variant="outlined"
                                label="Nome"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                margin="normal"
                                fullWidth
                                disabled={!isEditing}
                            />
                            <TextField
                                variant="outlined"
                                label="Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                margin="normal"
                                fullWidth
                                disabled={!isEditing}
                            />
                            <TextField
                                variant="outlined"
                                label="Senha"
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                margin="normal"
                                fullWidth
                                disabled={!isEditing}
                            />
                            <Box display="flex" justifyContent="space-between" marginTop={2}>
                                {isEditing ? (
                                    <>
                                        <Button variant="contained" color="primary" onClick={handleSave}>Salvar</Button>
                                        <Button variant="outlined" color="secondary" onClick={handleEditToggle}>Cancelar</Button>
                                    </>
                                ) : (
                                    <Button variant="contained" color="primary" onClick={handleEditToggle}>Editar</Button>
                                )}
                            </Box>
                        </Box>
                    ) : (
                        <Typography sx={{ textAlign: 'center' }}><CircularProgress/></Typography>
                    )}
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Perfil;
